class SubMenu {
  constructor(subMenuElement, parent) {
    this.subMenu = subMenuElement;
    this.parent = parent;
    this.firstChild = this.parent.children[0];
    this.init();
  }

  init() {
    this.subMenu.classList.remove('sub-menu');
    this.subMenu.classList.add('sub-menu__container');
    this.wrapper = this.setContent();
    this.parent.append(this.wrapper);
  }
  setContent() {
    const content = document.createElement('div');
    content.classList.add('sub-menu');
    content.appendChild(this.setLeftPart());
    content.appendChild(this.setRightPart());

    return content;
  }

  setLeftPart() {
    const leftPart = document.createElement('div');
    leftPart.classList.add('sub-menu__left-part');
    const title = document.createElement('p');
    title.classList.add('sub-menu__title');
    title.classList.add('heading');
    title.classList.add('heading--h3');
    title.innerText = this.getTitle();
    leftPart.appendChild(title);
    leftPart.appendChild(this.subMenu);

    return leftPart;
  }

  setRightPart() {
    const menuItemImage = this.parent.querySelector('a img');
    const rightPart = document.createElement('div');
    rightPart.classList.add('sub-menu__right-part');
    if (menuItemImage) {
      rightPart.appendChild(menuItemImage);
    }

    return rightPart;
  }

  getTitle() {
    return this.firstChild.innerText;
  }
}

export default SubMenu;
